var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 1V5.5C9.66667 6.12132 10.189 6.625 10.8333 6.625H15.5M9.86683 1H3.83333C2.54467 1 1.5 2.00736 1.5 3.25V16.75C1.5 17.9926 2.54467 19 3.83333 19H13.1667C14.4553 19 15.5 17.9926 15.5 16.75V6.43198C15.5 5.83524 15.2542 5.26295 14.8166 4.84099L11.5168 1.65901C11.0792 1.23705 10.4857 1 9.86683 1Z",
    stroke: "#393736",
    strokeOpacity: 0.87,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.7e6799fb2d2ba5a0e4e32b6d878e511b.svg";
export { ForwardRef as ReactComponent };